import { NameFormat } from '../../../../packages/types/football';

export const formatPlayerName = (name: string, nameFormat: NameFormat): string => {
  const cleanedName = name.replace(/['"]/g, '').trim();
  const nameParts = cleanedName.split(' ');
  if (nameParts.length === 1) return cleanedName;

  const lastName = nameParts.pop() || '';
  const initials = nameParts.map((part) => part[0].toUpperCase()).join('. ');

  return nameFormat === NameFormat.INITIALS ? `${initials}. ${lastName}` : `${lastName}`;
};
